import {
    Component, Prop, Mixins, PropSync,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Chips Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Tag name used to render chips's element
     */
    @Prop({ type: String, default: 'span' }) tag!: string;

    /**
     * Href for `a` tag
     */
    @Prop({ type: String }) href!: string;

    /**
     * to for `router-link` tag
     */
    @Prop({ type: Object }) to!: Record<string, unknown>;
    
    /**
     * Icon Prepend
     */
    @PropSync('icon', { type: String }) iconPrepend!: string;

    /**
     * Icon Append
     */
    @Prop({ type: String }) iconAppend!: string;

    /**
     * Actionable Close Icon
     */
    @Prop({ type: Boolean }) closeable!: boolean;

    /**
     * Badge Prepend
     */
    @PropSync('badge', { type: String }) badgePrepend!: string;

    /**
     * Badge Append
     */
    @Prop({ type: String }) badgeAppend!: string;

    /**
     * Text
     */
    @Prop({ type: Boolean }) text!: boolean;

    /**
     * Icons library code name. here's a list of supported icons libraries:
     * 'mdi' - Material Design Icons - https://materialdesignicons.com/
     * 'fa' - Font Awesome - https://fontawesome.com/icons
     */
    @Prop({ type: String, default: 'fa' }) library!: string;

    /**
     * Prefix of the icon
     * Font Awesome prefix: 'fab', 'far', 'fas'.
     */
    @Prop({ type: String, default: 'fas' }) prefix!: string

    /**
     * Set transition onload chips
     */
    @Prop({ type: String, default: 'fade' }) transition!: string;

    /**
     * Change color badge
     */
    @Prop({ type: Boolean }) reverse!: boolean;

    /**
     * Ignore content and set border-radius:50% in badge
     */
    @Prop({ type: Boolean }) dot!: boolean;

    /**
     * Set chips in monochrome mode
     */
    @Prop({ type: Boolean }) monochrome!: boolean;

    /**
     * Set background color in close icon
     */
    @Prop({ type: Boolean }) bgClose!: boolean;

    /**
     * Anchor target
     */
    @Prop({ type: String, default: '_self' }) target!: string;

    /**
     * Disable State
     */
    @Prop({ type: Boolean }) disabled!: boolean;
}

export default Props;
